import { useAuthStore } from '@/store/auth'
import { useOrganizationStore } from '@/store/organization'
import { useAuth } from '@workos-inc/authkit-react'
import { useEffect } from 'react'

export const WorkosAuthLoader = () => {
  const {
    isLoading,
    user,
    signOut,
    getAccessToken,
    switchToOrganization,
    organizationId,
  } = useAuth()
  const setAuthState = useAuthStore((s) => s.setAuthState)
  const setOrganizationState = useOrganizationStore(
    (s) => s.setOrganizationState,
  )

  useEffect(() => {
    setAuthState({
      accessTokenGetter: getAccessToken,
      isLoadingExternalAuth: isLoading,
      hasExternalAuth: !!user,
      signOut: (options) =>
        signOut({
          returnTo: options?.redirectUrl ?? window.location.origin,
        }),
    })
  }, [setAuthState, isLoading, user, signOut, getAccessToken])

  useEffect(() => {
    if (switchToOrganization) {
      setOrganizationState({
        setActiveExternalOrganization: (orgId) =>
          switchToOrganization({ organizationId: orgId }),
      })
    }
  }, [switchToOrganization, setOrganizationState])

  useEffect(() => {
    setOrganizationState({
      externalOrganizationId: organizationId ?? undefined,
    })
  }, [organizationId, setOrganizationState])

  return null
}
